import { Fragment, PropsWithChildren, ReactNode } from 'react';
import cns from 'classnames';
import S from './AsideWithLayout.module.scss';
const _AsideWithLayout = () => <></>;
const Wrapper = ({
  children
}: PropsWithChildren) => {
  return <div className={S.layout} data-sentry-component="Wrapper" data-sentry-source-file="AsideWithLayout.tsx">{children}</div>;
};
const Header = ({
  title,
  breadcrumbs
}: {
  title: ReactNode;
  breadcrumbs: ReactNode[];
}) => {
  return <header className={S.header} data-sentry-component="Header" data-sentry-source-file="AsideWithLayout.tsx">
      <h1 className={S.title}>{title}</h1>
      <span className={S.breadcrumb}>
        {breadcrumbs.map((node, idx) => <Fragment key={idx}>
            <span>{node}</span>
            {idx !== breadcrumbs.length - 1 && <span className={S.line} />}
          </Fragment>)}
      </span>
    </header>;
};
const Container = ({
  children
}: PropsWithChildren) => {
  return <div className={S.container} data-sentry-component="Container" data-sentry-source-file="AsideWithLayout.tsx">{children}</div>;
};
const Content = ({
  children
}: PropsWithChildren) => {
  return <main className={S.content} data-sentry-component="Content" data-sentry-source-file="AsideWithLayout.tsx">{children}</main>;
};
const SideButtons = ({
  menuItems
}: {
  menuItems: AsideWithLayoutMenusProp;
}) => {
  return <aside className={S.sidebar} data-sentry-component="SideButtons" data-sentry-source-file="AsideWithLayout.tsx">
      <ul className={S.menu}>
        {menuItems.map(menuItem => <li key={menuItem.id} className={S.menu_item}>
            <div className={cns(S.menu_button, {
          [S.active]: menuItem.isActive
        })}>
              {menuItem.render}
            </div>
          </li>)}
      </ul>
    </aside>;
};
/***
  사이드 버튼이 존재하는 NestedLayout 입니다.
  <Wrapper>
    <Header></Header>(옵셔널)
    <Container>
      <SideButtons></SideButtons>(옵셔널)
      <Content></Content>
    </Container>
  </Wrapper>
 */

export const AsideWithLayout = Object.assign(_AsideWithLayout, {
  Wrapper,
  Header,
  Container,
  Content,
  SideButtons
});
export type AsideWithLayoutMenusProp = {
  render: ReactNode;
  isActive: boolean;
  id: number | string;
}[];